import React from 'react';
import { PatternFormat } from 'react-number-format';
import { useTranslation } from 'react-i18next';

import { TextField } from '@vivaahealth/design-system';

import styles from './index.module.css';

interface Props {
  input: string;
  errorMessage: string;
  onEnterGenerateCode: (key: string) => Promise<void>;
  onChangeInput: (v: string) => void;
}

const InputEmail: React.FC<Props> = ({
  input,
  errorMessage,
  onEnterGenerateCode,
  onChangeInput,
}) => {
  const { t } = useTranslation('common');

  return (
    <PatternFormat
      autoFocus
      className={errorMessage && styles['text-field-error']}
      customInput={TextField}
      format="(###) ###-####"
      inputMode="numeric"
      onValueChange={(e) => onChangeInput(e.value)}
      placeholder={t('mobilePhoneNumber')}
      value={input}
      valueIsNumericString
      onKeyDown={async (e) => await onEnterGenerateCode(e.code)}
    />
  );
};

export default InputEmail;
